// AGC: Admin loading state — spinner or skeleton
import React from 'react'
import { Loader2 } from 'lucide-react'

interface AdminLoadingStateProps {
  message?: string
  className?: string
}

export const AdminLoadingState: React.FC<AdminLoadingStateProps> = ({
  message,
  className = '',
}) => (
  <div className={`flex flex-col items-center justify-center py-16 ${className}`}>
    <Loader2 className="w-8 h-8 text-brand-primary dark:text-brand-light animate-spin mb-3" />
    {message && (
      <p className="text-sm text-slate-500 dark:text-slate-400">{message}</p>
    )}
  </div>
)
